import { createI18n } from 'vue-i18n';

import en from '../../lang/en.json';
import es from '../../lang/es.json';
import ru from '../../lang/ru.json';
import ua from '../../lang/ua.json';
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import {setDatesLocale} from "@/shared/helpers/dates.js";
import {getLocale} from "@/shared/helpers/locale.js";

dayjs.extend(localizedFormat);

const locale = getLocale();

const datetimeFormats = {
    'ru': {
        long_with_time: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }
    },
    'ua': {
        long_with_time: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }
    },
    'en': {
        long_with_time: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }
    },
    'es': {
        long_with_time: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }
    }
};

setDatesLocale(locale);


function customRule(choice, choicesLength, orgRule) {
    const absChoice = Math.abs(choice);

    let cases = [2, 0, 1, 1, 1, 2];

    return Math.min(
        choicesLength,
        (absChoice % 100 > 4 && absChoice % 100 < 20) ? 2 : cases[(absChoice % 10 < 5) ? absChoice % 10 : 5]
    );
}

export const i18n = createI18n({
    locale: locale, // Язык по умолчанию
    fallbackLocale: 'en',
    messages: {
        en,
        es,
        ru,
        ua
    },
    legacy: false,
    datetimeFormats,
    pluralRules: {
        ru: customRule
    }
});

